import { createContext, useContext, useEffect, useState } from "react";
import { content } from "@/data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("ar");

  useEffect(() => {
    const dir = content[lang].dir;
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    document.title =
      lang === "ar"
        ? "عبدالرحمن الهادي | مؤثر تقني موثوق — احجز حملتك الإعلانية"
        : "Abdulrahman Al-Hadi | Trusted Tech Influencer — Book Your Campaign";

    // Swap OG / Twitter image + locale by language
    const origin = window.location.origin;
    const ogPath = lang === "ar" ? "/og-image.png" : "/og-image-en.png";
    const setMeta = (selector, val) => {
      const el = document.head.querySelector(selector);
      if (el) el.setAttribute("content", val);
    };
    setMeta('meta[property="og:image"]', origin + ogPath);
    setMeta('meta[property="og:image:secure_url"]', origin + ogPath);
    setMeta('meta[name="twitter:image"]', origin + ogPath);
    setMeta('meta[property="og:locale"]', lang === "ar" ? "ar_SA" : "en_US");
  }, [lang]);

  const toggleLang = () => setLang((p) => (p === "ar" ? "en" : "ar"));

  const t = content[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
